import React, { memo } from 'react';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import DefaultProductImage from '../img/product/default-home_default.jpg';
import NumberFormatter from "./NumberFormatter";
import UseMediaQuery from "./UseMediaQuery";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation,Pagination  } from 'swiper/modules';


const ProductCard = memo(({ product, loadingProductId, handleAddToCart }) => {
    const isMobile = UseMediaQuery("(max-width: 768px)");

     const sortedImages = [...(product.stthemeeditor.images || [])].sort((a, b) => {
        return (String(b.cover) === "1") - (String(a.cover) === "1");
    });

    return (
        <div className="product-pro cart">
           
            {!isMobile? (
                <div className="product-img-top">
                    {product.cover === null ? 
                    (<Link to={`/${product.id_product}-${product.link_rewrite}.html`}>
                        <LazyLoad
                            height={320}
                            offset={100}
                            placeholder={
                                <div className="loading-placeholder">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            }
                        >
                            <img
                                src={DefaultProductImage}
                                alt={product.name}
                            />
                        </LazyLoad> 
                    </Link> )
                     : (   
                    <Swiper
                        slidesPerView={1}
                        modules={[FreeMode, Navigation,Pagination]}
                        lazy={{ loadPrevNext: true }}
                        pagination={{ clickable: true }}
                        className="MobileProductSwiper"
                    >
                        {sortedImages.map((img, index) => ( 
                            
                            <SwiperSlide key={index}>
                                <Link to={`/${product.id_product}-${product.link_rewrite}.html`}>
                                    <img
                                        src={img.bySize.home_default.url}
                                        alt={product.name}
                                        className="swiper-lazy"
                                        style={{
                                        width: "280px",
                                        height: "320px",
                                        cursor: "pointer",
                                        }}
                                    />
                                    <div className="swiper-lazy-preloader"></div>
                                </Link> 
                            </SwiperSlide>
                        ))}
                    </Swiper>
                        
                    )}
                
                    {/* تصویر hover */}
                    {/*product.sthoverimage !== false && (
                        <LazyLoad height={320} offset={100}>
                            <img
                                className="product-hover-image"
                                src={product.sthoverimage.bySize.home_default.url}
                                alt={`${product.name} hover`}
                            />
                        </LazyLoad>
                    )*/}
                </div>):(
                <div className="product-img-top">
                    {product.cover === null?
                    <Link to={`/${product.id_product}-${product.link_rewrite}.html`}>
                    <LazyLoad
                        height={320}
                        offset={100}
                        placeholder={
                            <div className="loading-placeholder">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        }
                        style={{
                            textAlign:"center"
                        }}
                    >
                        <img
                            src={product.cover === null ? DefaultProductImage : product.cover.url}
                            alt={product.name}
                             style={{
                                width: "162px",
                                height: "200px",
                                cursor: "pointer",
                                }}
                        />
                    </LazyLoad>
                    </Link>
                    :
                     <Swiper
                        slidesPerView={1}
                        modules={[FreeMode, Navigation,Pagination]}
                        lazy={{ loadPrevNext: true }}
                        pagination={{ clickable: true }}
                        className="MobileProductSwiper"
                    >
                        {sortedImages.map((img, index) => ( 
                            <SwiperSlide key={index}>
                                <Link to={`/${product.id_product}-${product.link_rewrite}.html`}>
                                <img
                                    src={img.bySize.home_default.url}
                                    alt={product.name}
                                    className="swiper-lazy"
                                    style={{
                                    width: "162px",
                                    height: "200px",
                                    cursor: "pointer",
                                    }}
                                />
                                <div className="swiper-lazy-preloader"></div>
                                </Link>
                            </SwiperSlide>
                        ))}
                        {/*product.sthoverimage !== false && (
                            <SwiperSlide>
                                <img
                                    src={product.sthoverimage.bySize.home_default.url}
                                    alt={`${product.name} hover`}
                                    className="swiper-lazy"
                                    style={{
                                    width: "162px",
                                    height: "200px",
                                    cursor: "pointer",
                                    }}
                                />
                                <div className="swiper-lazy-preloader"></div>
                            </SwiperSlide>
                        )*/}
                    </Swiper>
                    }
                </div>
            )}
           
            <div className="card-body text-center">
                <Link
                    to={`/${product.id_product}-${product.name}.html`}
                    className="link-underline link-underline-opacity-0 card-title"
                >
                    <h5 className="card-title text-truncate">
                        {product.name.length > 100
                        ? product.name.slice(0, 20) + '...'
                        : product.name}
                    </h5>
                </Link>
                {product.quantity > 0 ? (
                <div className="product-price">
                <span className="price"><NumberFormatter className='ms-2' amount={product.price_amount} locale ='en-us'/> ریال</span>
                </div>
                ):(<div className='out-of-stock'>اتمام موجودی</div>)}
                {/*product.quantity > 0 && (
                    <button
                        className="btn add-to-cart"
                        onClick={() => handleAddToCart(product)}
                        disabled={loadingProductId === product.id_product}
                    >
                        {loadingProductId === product.id_product && (
                            <span
                                className="spinner-border spinner-border-sm mx-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                        افزودن به سبد خرید
                    </button>
                )*/}
                
                    <Link
                        className="btn add-to-cart"
                        to={`/${product.id_product}-${product.name}.html`}
                        //onClick={() => handleAddToCart(product)}
                        disabled={loadingProductId === product.id_product}
                    >
                        {loadingProductId === product.id_product && (
                            <span
                                className="spinner-border spinner-border-sm mx-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                        {product.quantity > 0 ? "افزودن به سبد خرید":"موجود شد به من اطلاع بده"}
                    </Link>
                    
                
            </div>
        </div>
    );
});

export default ProductCard;
